import React, { useEffect, useState } from 'react';
import { Form, Input, Radio } from '@roo/roo';
import styled from 'styled-components';
import file_icon from '@assets/images/file.svg';
import { getS3DownloadUrl, getS3PreviewUrl } from '@assets/apis/base';
import { getLocalUserData } from '@components/UserData/user';
import { getAllReportDirec } from '@assets/apis/innovate';
import { useUserData } from '@components/UserData';
import { EditorField } from '../../apply/scientist/apply';
import '../index.scss';

const Root = styled.div`
  p:not(:first-child) {
    margin-top: 12px;
  }
`;

export function Area(props) {
  const { value = [] } = props;
  const { subjects = [], sub2 = [] } = useUserData();
  function getPathName(path = '') {
    let arr = [...subjects, ...sub2];
    let ch = arr.shift();
    try {
      while (ch) {
        if (ch.path === path) {
          return (ch?.pathName || '').replace(/\-/g, '/');
        }
        if (Array.isArray(ch.children)) {
          arr = arr.concat(ch.children);
        }
        ch = arr.shift();
      }
    } catch (e) {
      return '';
    }
    return '';
  }

  return (
    <Root>
      {(value||[]).map((k, i) => <p key={i}>{getPathName(k)}</p>)}
    </Root>
  );
}

const { Textarea } = Input;
const { Group: RadioGroup } = Radio;

function getFileList(fileUrls = []) {
  if (typeof fileUrls === 'string') {
    fileUrls = [fileUrls];
  }
  if (!Array.isArray(fileUrls)) return null;
  return fileUrls.filter(Boolean).map((url, idx) => {
    const xs = url.split('({&!$!&})');
    return {
      name: xs.pop(),
      url,
      key: url,
    };
  });
}

export const defaultCols = { field: { span: 9, offset: 0 }, label: { span: 3 } };

export const renderTextArea = (item, key) => {
  const value = item[key];
  return (
    <Textarea value={value} disabled />
  );
};

export const renderEditor = (item, key) => {
  const value = item[key];
  return (
    <EditorField value={value} disabled onChange={Function.prototype} />
  );
};

export const renderDirection = (item) => {
  const { inoProjectConfigId } = useUserData();
  const [opts, setOpt] = useState([]);
  useEffect(() => {
    getAllReportDirec({ projectConfigId: inoProjectConfigId }, 7)
      .then((res) => {
        const directions = res?.directions;
        directions && setOpt(directions);
      });
  }, []);
  const value = item.reportDirection;
  return (
    <RadioGroup value={value} disabled>
      {opts.map((item, index) => <Radio value={item.id} key={index}>{item.name}</Radio>)}
    </RadioGroup>
  );
};

export const renderFile = (item, key = 'paperUrl') => {
  if (!item) return null;
  const fileUrl = Array.isArray(item) ? item : item[key];
  const fileList = getFileList(fileUrl);
  return fileList && fileList.length ? (
    <div>
      {
        fileList.map((file) => {
          const { name, key, url } = file;
          return (
            <div
              className="preview-letter" key={key} onClick={() => {
                const { mtUid } = getLocalUserData();
                getS3DownloadUrl({ fileName: key, userId: mtUid, needWatermark: true }).then((res) => {
                  window.open(res, '_blank');
                });
              }}
            >
              <img src={file_icon} style={{ marginRight: '8px', width: '14px' }} />
              <span>
                {name}
              </span>
            </div>
          );
        })
      }
    </div>
  ) : null;
};

export const renderFileForPreview = (item, key = 'paperUrl') => {
  if (!item) return null;
  const fileUrl = Array.isArray(item) ? item : item[key];
  const fileList = getFileList(fileUrl);
  return fileList && fileList.length ? (
    <div>
      {
        fileList.map((file) => {
          const { name, key, url } = file;
          return (
            <div
              className="preview-letter" key={key} onClick={() => {
                getS3PreviewUrl({ objectName: key }).then((res) => {
                  window.open(res, '_blank');
                });
              }}
            >
              <img src={file_icon} style={{ marginRight: '8px', width: '14px' }} />
              <span>
                {name}
              </span>
            </div>
          );
        })
      }
    </div>
  ) : null;
};

export const renderDetailByColumns = (info, columns, cols = defaultCols) => (
  <div className="preview-item-wrap">
    <div className="preview-item-wrap-withoutbackground">
      <Form cols={cols}>
        {
          columns.map((item) => {
            const {
              key, label, _render, layout = 'horizontal', required = true,
            } = item;
            return layout === 'vertical' ? (
              <div key={key} className='apply-quill-item'>
                <Form.Field
                  label={label}
                  required={required}
                  cols={{ label: { span: 6 } }}
                  className="preview-item-text"
                >
                  <span />
                </Form.Field>
                <Form.Field
                  withLabel={false}
                  className="preview-item-text"
                >
                  {
                    info ? (_render ? _render(info, key) : (<span className="control-field">{String(info[key] || '')}</span>)) : label
                  }
                </Form.Field>
              </div>
            ) : (
              <Form.Field
                key={key}
                label={label}
                required={required}
                className="preview-item-text"
              >
                {
                  info ? (_render ? _render(info, key) : (<span className="control-field">{String(info[key] || '')}</span>)) : label
                }
              </Form.Field>
            );
          })
        }
      </Form>
    </div>
  </div>
);

export const renderDetailListByColumns = (list, columns, cols = defaultCols) => (list ? (
  <div className="preview-item-wrap">
    <Form cols={cols}>
      {
        list.map((item, index) => (
          <div className="preview-item-wrap-withbackground" key={index}>
            <Form cols={cols}>
              {
                columns.map((itemColumn) => {
                  const {
                    key, label, _render, layout = 'horizontal', required = true,
                  } = itemColumn;
                  return layout === 'vertical' ? (
                    <div key={key}>
                      <Form.Field
                        cols={{ label: { span: 6 } }}
                        label={label}
                        required={required}
                        className="preview-item-text"
                      >
                        <span />
                      </Form.Field>
                      <Form.Field
                        withLabel={false}
                        className="preview-item-text"
                      >
                        {
                          _render ? _render(item, key) : (<span className="control-field">{String(item[key] || '')}</span>)
                        }
                      </Form.Field>
                    </div>
                  ) : (
                    <Form.Field
                      key={key}
                      label={label}
                      required={required}
                      layout={layout}
                      cols={cols}
                    >
                      {
                        _render ? _render(item, key) : (<span className="control-field">{String(item[key] || '')}</span>)
                      }
                    </Form.Field>
                  );
                })
              }
            </Form>
          </div>
        ))
      }
    </Form>
  </div>
) : null);
